import React from 'react';
import { Check } from 'lucide-react';
import { Reveal } from '../Reveal';
import { SectionBand, Eyebrow } from './SectionBand';
const youBring = ['The book', 'Existing offers', 'Point of view', 'Judgment', 'Brand materials', 'A few focused working sessions'];
const weBuild = ['Reader strategy', 'Diagnostic & readout', 'A guide to where your ideas apply', 'Interactive application of the ideas', 'Signals that show what readers need', 'Routing to the right offer', 'Business-building assets', 'Copy', 'Design', 'Implementation', 'Launch support'];
export function DoneForYou() {
  return <SectionBand tone="paperDark" width="wide" data-id="element-718" data-mp="20clgl8qrj09j">
      <div className="max-w-3xl" data-id="element-719" data-mp="20dwjz7gaq604">
        <Reveal data-id="element-720" data-mp="25bfx2419ccqh">
          <Eyebrow data-id="element-721" data-mp="25awp9g5bn4q6">Done for you</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl leading-tight text-navy md:text-5xl" data-id="element-722" data-mp="25by0bkmc7r7w">
            You wrote the book.
            <br data-id="element-723" data-mp="1rdrmbp0wmlz5" />
            <span className="italic text-seaglass" data-id="element-724" data-mp="1vd8skko5nn5d">
              We build the leverage around it.
            </span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid items-start gap-6 lg:grid-cols-[0.72fr_1.28fr] lg:gap-8" data-id="element-725" data-mp="1xsqemnri6yg2">
        <Reveal delay={0.1} data-id="element-726" data-mp="1suf6qikrqy0h">
          <div className="rounded-3xl border border-gray-200 bg-paper p-7 md:p-8" data-id="element-727" data-mp="1sxb5g94fxqpz">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-text-muted" data-id="element-728" data-mp="27rpna6c9qu32">
              You bring
            </p>
            <ul className="mt-5 space-y-3" data-id="element-729" data-mp="1f3tl4m3xk9yw">
              {youBring.map(item => <li key={item} className="flex items-start gap-3 text-text" data-id="element-730" data-mp="1f439k59bu92h">
                  <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-text-muted/50" data-id="element-731" data-mp="1a61pbh0603pf" />
                  <span className="leading-relaxed" data-id="element-732" data-mp="1ouepkq6ac8pq">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.15} data-id="element-733" data-mp="1k122ikh989z3">
          <div className="rounded-3xl border-2 border-seaglass bg-navy p-7 text-paper shadow-[0_30px_60px_-28px_rgba(26,40,56,0.6)] md:p-9" data-id="element-734" data-mp="wcskzur2q8dr">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-seaglass-light" data-id="element-735" data-mp="rdpqh48pzkk1">
              We build
            </p>
            <ul className="mt-5 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-736" data-mp="1l3ykz0cqknnu">
              {weBuild.map(item => <li key={item} className="flex items-start gap-3" data-id="element-737" data-mp="1l1ltnwl390y4">
                  <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-seaglass-ink text-white" data-id="element-738" data-mp="1pv873qz2t8uz">
                    <Check className="h-3 w-3" strokeWidth={3} data-id="element-739" data-mp="y3impn68gaoi" />
                  </span>
                  <span className="leading-relaxed text-paper/90" data-id="element-740" data-mp="y5vcunm59rcn">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.2} data-id="element-741" data-mp="173fg223khxpw">
        <p className="mx-auto mt-12 max-w-2xl text-center text-lg text-text-muted" data-id="element-742" data-mp="176a0vuqhtkju">
          <span className="block" data-id="element-743" data-mp="1c4l961153mzy">You stay the author and the expert.</span>
          <span className="mt-1 block" data-id="element-744" data-mp="2iiaubmyaxx5x">
            Our team does the build — you do not become a project manager or a
            tech manager.
          </span>
        </p>
      </Reveal>
    </SectionBand>;
}